import type { ValueOf } from 'type-fest';

export const BillingPlanFeature = {
  FEATURE_ADDITIONAL_EMPLOYEE: 'additional_employee',
  FEATURE_MARKETING: 'marketing',
  FEATURE_QUICKBOOKS: 'quickbooks',
  FEATURE_QUICKBOOKS_DESKTOP: 'quickbooks_desktop',
  FEATURE_INTER_COMPANY_CHAT: 'inter_company_chat',
  FEATURE_SMS_NUMBER: 'sms_number',
  FEATURE_EMPLOYEE_LIVE_MAP: 'employee_live_map',
  FEATURE_CUSTOM_REPORT: 'employee_custom_report',
  FEATURE_DEFAULT_REPORT: 'employee_default_report',
  FEATURE_EMPLOYEE_REPORT: 'employee_report',
  FEATURE_TAGS_REPORT: 'tags_report',
  FEATURE_BOOKING_WIDGET: 'booking_widget',
  FEATURE_TIME_TRACKING: 'time_tracking',
  FEATURE_EMPLOYEE_TIME_TRACKING: 'employee_time_tracking',
  FEATURE_UNLIMITED_EMPLOYEES: 'unlimited_employees',
  FEATURE_ADD_JOBS: 'add_jobs',
  FEATURE_ZAPIER: 'zapier',
  FEATURE_SERVICE_AGREEMENTS: 'service_agreements',
  FEATURE_STRIPE_TERMINAL: 'stripe_terminal',
  FEATURE_CARD_ON_FILE: 'card_on_file',
  FEATURE_WEB_HOSTING: 'web_hosting',
  FEATURE_OLD_MOBILE_BILLING: 'old_mobile_billing',
  FEATURE_SALES_PROPOSAL: 'sales_proposal',
  FEATURE_ADVANCED_REPORTING: 'advanced_reporting',
  FEATURE_PROPERTY_PROFILE: 'property_profile',
  FEATURE_CALL_RAIL: 'call_rail',
  FEATURE_CHECKLISTS: 'checklists',
  FEATURE_MAILCHIMP: 'mailchimp',
  FEATURE_PREMIUM_REVIEWS: 'premium_reviews',
  FEATURE_JOB_COST: 'job_cost',
  FEATURE_PURCHASE_ORDERS: 'purchase_orders',
  FEATURE_CUSTOM_FIELDS: 'custom_fields',
  FEATURE_VIRTUAL_ESTIMATE: 'virtual_estimate',
  FEATURE_E_COMMERCE: 'e_commerce',
  FEATURE_WEBHOOKS: 'webhooks',
  FEATURE_VISUAL_PRICE_BOOK: 'visual_price_book',
  FEATURE_FLAT_RATE_PRICING: 'flat_rate_pricing',
  FEATURE_LEAD_SOURCE: 'lead_source',
  FEATURE_TIME_TRACKING_BY_TECH: 'time_tracking_by_tech',
  FEATURE_HCP_ASSIST: 'hcp_assist',
  FEATURE_CALL_TRACKING: 'call_tracking',
  FEATURE_VOIP: 'voip',
  FEATURE_PROFIT_RHINO: 'profit_rhino',
  FEATURE_VEHICLE_TRACKING: 'vehicle_tracking',
  FEATURE_SALES_MANAGEMENT: 'sales_management',
  FEATURE_ENHANCED_JOB_COSTING: 'job_cost',
  FEATURE_CIF: 'customer_intake_flow',
  FEATURE_INVOICES_LITE: 'invoices_lite',
  FEATURE_CUSTOMERS: 'customers',
  FEATURE_ONLINE_PAYMENTS: 'online_payments',
  FEATURE_ONLINE_PAYMENTS_CARD_READER: 'online_payments.card_reader',
  FEATURE_HCP_MONEY: 'hcp_money',
  FEATURE_ACCOUNTING: 'accounting',
  FEATURE_PAYROLL: 'payroll',
  FEATURE_BUSINESS_LENDING: 'business_lending',
  FEATURE_CONSUMER_FINANCING: 'consumer_financing',
} as const;

export type BillingPlanFeatureType = ValueOf<typeof BillingPlanFeature>;
